import { Pipe, PipeTransform } from '@angular/core';
import get from 'lodash/get';
import {isNotEmpty} from "../../core/utils/functions";

@Pipe({
  name: 'tableFieldPipe',
  standalone: true,
})
export class TableFieldPipe implements PipeTransform {
  transform(value: any, args?: string): any {
    const result = get(value, args!);
    return isNotEmpty(result) ? result : '---';
  }
}
